import Pqp from "../../../3x1010/Pqp.js";
import Game from "../../Game.js";
import Maze from "../../maze/Maze.js";
import MazeConst from "../../maze/MazeConst.js";
import MazeRenderDebug from "../../maze/MazeRenderDebug.js";
import SpriteProvider from "../../utils/SpriteProvider.js";
import CellRender from "../../maze/render/CellRender.js";
import Door from "../mobs/Door.js";
import PermissiveFov from "../../utils/permissiveFov/PermissiveFov.js";
import Torch from "../tileAnimation/Torch.js";
import Hero from "../mobs/Hero.js";
import Control from "../controllers/Control.js";
import Skills from "../skills/Skills.js";
import Player from "../../bout/Player.js";
import Helper from "../../utils/helper/Helper.js";
import Message from "./Message.js";
import Bout from "../../bout/Bout.js";
import Screen from "../Screen.js";
import Spike from "../tileAnimation/Spike.js";

export default class TileMap {
	constructor(model, rows, cols, sprites, callback) {
		this.model = model;
		this.rows = rows;
		this.cols = cols;
		this.oriRows = rows;
		this.oriCols = cols;
		this.tilew = -1;
		this.tileh = -1;
		this.sprites = sprites;
		this.sp = new SpriteProvider(this.sprites);
		this.mobs = new Array();
		this.mobInCamera = null;
		this.currentBoundingBox = null;
		this.deltax = 0;
		this.deltay = 0;
		this.fov = false;
		this.fovCells = new Array();
		this.oldFovCells = null;
		this.callback = callback;
		this.destroyed = false;
		this.introShown = false;
		this.closedEntrance = false;
		this.levelWon = false;
		this.outroShown = false;
		this.stoppedInteractionAtEndLevel = false;
		this.toMove = new Array();
		this.toInteract = new Array();
		this.fovThingsToShow = new Array();
		this.decisionsInProgress = new Array();
		this.chestsCurrentOpened = new Array();
		this.torchChecked = new Array();
	}

	init() {

		let clip = jQuery("#template-tilemap").clone();
		clip.attr("id", "tilm" + TileMap.ENUM++)
		this.mc = clip;
		this.loader = jQuery(".js-tilemap-loader", this.mc)
		let det = Screen.that.featurer.getCurrentLevelDetails();
		if (det.level === "0") {
			jQuery(".js-load-msg", this.mc).text("Entering the dungeon...");
		}

		this.areaLayers = jQuery(".js-area-layers", this.mc)

		this.setTileSize();
		this.setAreaSize();
		this.setAreaMessages();
	}

	destroy() {
		this.destroyed = true;
		for (let x = 0; x < this.mobs.length; x++) {
			this.mobs[x].destroy();
			this.mobs[x].mc.remove();
		}
		let a = jQuery(".maze-tile", this.areaLayers);
		for (let x = 0; x < a.length; x++) {
			let ref = (a[x].getAttribute("data-ref")).split("|");
			let cell = this.model.getCellDirect(ref[0], ref[1]);
			cell.activateTilesAnimations(false);
			this.removeTile(cell);
		}
		this.mc.remove();

	}

	setTileSize() {
		this.tilew = Game.TILE_WIDTH_MAP;
		this.tileh = Game.TILE_HEIGHT_MAP;
	}

	setAreaSize() {
		this.mc.width(this.cols * this.tilew);
		this.mc.height(this.rows * this.tileh);
	}

	setLoadingMessage(msg) {
		jQuery(".js-message", this.loader).text(msg);
	}

	initMap() {
		this.loader.hide();
		if (this.model.hasFov()) {
			this.mc.addClass("tilemap-black")
		}

		this.createLayers();
		this.initPFov();
	}


	initPFov() {
		if (this.model.hasFov()) {
			this.pfov = new PermissiveFov(this.model.cols, this.model.rows, this.isCellTransparent.bind(this));
			this.createFovLayer();
		} else {
			jQuery(".js-layer-fov", this.mc).remove();
		}
	}

	createFovLayer() {
		this.fovTiles = jQuery(".js-fovs", this.mc);
	}

	isCellTransparent(row, col, mob = null) {
		let cell = this.model.maze[row][col];

		if (cell.isWall()) {
			return false;
		}
		if (cell.isColumn()) {
			return true;
		}
		if (cell.isHorizontalDoor()) {
			if (cell.isLockedDoor()) {
				return false;
			} else {
				if (mob) {
					if (!mob.canOpenDoors()) {
						if (cell.mobGenerated.closed) {
							return false;
						}
					}
				}
			}
		}
		if (cell.isSecretExit()) {
			return false;
		}


		return true;
	}


	attachCamera(mob) {
		// Attacca la camera ad un mob
		this.mobInCamera = mob;
		this.goto(mob.cell);
	}

	createLayers() {
		// Crea i layers delle tiles
		if (this.layersPanel) {
			this.layersPanel.remove();
		}
		this.layersPanel = jQuery("#template-tiles-layers").clone();
		this.layersPanel.attr("id", "tila" + TileMap.ENUM++);
		this.layersPanel.width(this.model.cols * this.tilew);
		this.layersPanel.height(this.model.rows * this.tileh);
		this.areaLayers.append(this.layersPanel);

		// Controlla il caso particolare che la mappa sia più piccola della view
		let limitRow = this.rows;
		let limitCol = this.cols;

		if (this.model.rows < limitRow) {
			limitRow = this.model.rows;
		}
		if (this.model.cols < limitCol) {
			limitCol = this.model.cols;
		}

		this.rows = limitRow;
		this.cols = limitCol;

		let deltax = Math.floor((this.oriCols - limitCol) / 2);
		let deltay = Math.floor((this.oriRows - limitRow) / 2);
		if (deltax < 0) deltax = 0;
		if (deltay < 0) deltay = 0;


		this.deltax = deltax;
		this.deltay = deltay;
		//console.log(this.deltax, this.deltay)

		// Setta lo z-index
		let layers = jQuery(".tiles-layer", this.layersPanel);
		for (let x = 0; x < layers.length; x++) {
			jQuery(layers[x]).css("z-index", (x + 1) * 100);
			jQuery(layers[x]).css({ left: this.deltax * this.tilew, top: this.deltay * this.tileh });
			this.mc.addClass("tilemap-black")
			if (x > 0) {
				jQuery(layers[x]).css("pointer-events", "none");
			}

		}
		this.deltax = 0;
		this.deltay = 0;

	}

	resetLayers() {
		// Resetta i layers tranne quello che contiene i mob
		let lCondExit = false;
		let n = 0;
		while (!lCondExit) {
			let layer = jQuery(".js-layer-" + n, this.layersPanel);
			if (n === 0) {
				layer.addClass("layer-background-style-" + TileMap.STYLER.style);

			}
			if (n === 1) {
				layer.css("pointer-events", "none");
			}

			if (layer.length > 0) {
				let a = jQuery(".maze-tile", layer);
				for (let x = 0; x < a.length; x++) {
					let ref = (a[x].getAttribute("data-ref")).split("|");
					let cell = this.model.getCellDirect(ref[0], ref[1]);
					this.removeTile(cell);
				}
				n++;
			} else {
				lCondExit = true;
			}
		}
	}


	goto(cell) {
		// Resetta tutto lo screen (se esiste) centrandolo su una determinata cella
		let cells = this.centerOnCell(cell);

		// Resetta i layers (tranne i mob)
		this.resetLayers();


		// Piazza il contenitore di layers
		this.layersPanel.css({
			left: -cells[0][0].col * this.tilew,
			top: -cells[0][0].row * this.tileh,
		})

		// Crea le celle del bounding box
		for (let row = 0; row < this.rows; row++) {
			for (let col = 0; col < this.cols; col++) {
				let cell = cells[row][col];
				cell.createTiles(this.sp);
				this.placeTiles(cell, this.deltax, this.deltay);
			}
		}

		// Aggiunge le celle fuori dal bounding box
		this.addRemoveBoundingTilesFromPanel();

	}


	centerOnCell(cell) {
		// Prende le celle centrando nella view la cella passata
		let cells = new Array();
		let box = this.getBoundingBox(cell);
		this.currentBoundingBox = box;

		for (let row = box.top; row < box.bottom; row++) {
			cells.push(new Array())
			for (let col = box.left; col < box.right; col++) {
				cells[cells.length - 1].push(this.model.maze[row][col]);
			}
		}
		return cells;
	}

	getBoundingBox(cell) {
		// Prende il bounding box della cella facendo in modo che non sfori dal maze
		let cur_r = cell.row;
		let cur_c = cell.col;
		let map_r = this.model.rows;
		let map_c = this.model.cols;
		let area_r = this.rows;
		let area_c = this.cols;

		let to_top = Math.floor((area_r - 1) / 2);
		let top = cur_r;
		for (let x = 0; x < to_top; x++) {
			if (top > 0) {
				top -= 1;
			} else {
				break;
			}
		}

		let to_left = Math.floor((area_c - 1) / 2);
		let left = cur_c;
		for (let x = 0; x < to_left; x++) {
			if (left > 0) {
				left -= 1;
			} else {
				break;
			}
		}

		let to_bottom = area_r;
		let shift_top = 0;
		for (let x = 0; x < to_bottom; x++) {
			if (top + x >= map_r) {
				shift_top++;
			}
		}
		top -= shift_top;

		let to_right = area_c;
		let shift_left = 0;
		for (let x = 0; x < to_right; x++) {
			if (left + x >= map_c) {
				shift_left++;
			}
		}
		left -= shift_left;

		let bottom = top + area_r;
		let right = left + area_c;

		if (area_r > map_r) {
			top = 0;
			bottom = map_r;
		}
		if (area_c > map_c) {
			left = 0;
			right = map_c;
		}

		return { top: top, left: left, bottom: bottom, right: right };
	}

	checkPlayerInteractions() {
		this.toInteract.push({ type: "fired", priority: 1 });
	}


	moveMobTo(mob, incx, incy, lHelp = true) {
		this.toMove.push({ mob: mob, incx: incx, incy: incy, lHelp: true });
	}

	doMoveMobTo(mob, incx, incy, lHelp = true) {
		// Sposta il mob e se è nella camera, lo centra
		let can = this.canMoveMob(mob, incx, incy, lHelp);
		if (!can[0] && !can[1]) {
			return;
		}
		if (!can[0]) {
			if (can.length > 2) {
				incx = 0;
				incy = can[2];
			} else {
				incx = 0;
			}
		}
		if (!can[1]) {
			if (can.length > 2) {
				incy = 0;
				incx = can[2];
			} else {
				incy = 0;
			}
		}

		//let pos = mob.mc.position();
		let pos = mob.position();

		// Sposta il mob
		/*mob.mc.css({
			top: pos.top + incy,
			left: pos.left + incx
		});*/
		mob.top = pos.top + incy;
		mob.left = pos.left + incx;


		// Sposta la telecamera (se associata al mob che sta muovendo)
		if (this.mobInCamera) {
			if (this.mobInCamera.id === mob.id) {
				this.moveCamera(incx, incy);
			}
		}

		if (mob.cells) {
			mob.oldCells = mob.cells;
		}

		if (Game.DEBUG_MOB_CELLS) {
			if (mob.oldCells) {
				for (let x = 0; x < mob.oldCells.length; x++) {
					if (mob.oldCells[x]) {
						jQuery(".js-walkthrough", mob.oldCells[x].tiles[0]).css("display", "none");
						jQuery(".js-walkthrough", mob.oldCells[x].tiles[0]).removeClass("belong");
					}
				}
			}
		}

		// Prende le celle dove si trova il mob
		mob.cells = this.getCellsWhereMobStands(mob);
		// Controlla a quale cella "appartiene di più"
		let cellBelong = this.getCellMobBelongMore(mob, mob.cells);
		// e la setta come la corrente
		mob.oldCell = mob.cell;
		/*if (mob.clas === "enemy") {
			console.log(cellBelong.tiles[0])
		}*/
		mob.cell = cellBelong;

		// controlla le tiles vicine al mob per aggiustare le celle superiori
		this.checkCellsLevels(mob);

		// Controlla le tiles vicine per vedere se aprire una porta
		//this.checkCellsOpenCloseDoor(mob);


		if (Game.DEBUG_MOB_CELLS) {
			// Mostra la traccia
			for (let x = 0; x < mob.cells.length; x++) {
				if (mob.cells[x]) {
					if (mob.cell.id === mob.cells[x].id) {
						jQuery(".js-walkthrough", mob.cells[x].tiles[0]).addClass("belong");
					}
					jQuery(".js-walkthrough", mob.cells[x].tiles[0]).css("display", "block");
				}
			}
		}

	}

	checkCellsLevels(mob) {
		let around = this.model.getCellsAround(2, mob.cell);
		for (let x = 0; x < around.length; x++) {
			let tmp = around[x];
			if (tmp) {
				if (tmp.row < mob.cell.row) {
					if (tmp.tiles[1]) {
						tmp.hideSprite(tmp, 1, CellRender.LEVEL_BACKGROUND);
					}
				} else {
					if (tmp.tiles[1]) {
						tmp.showSprite(tmp, 1, CellRender.LEVEL_BACKGROUND);
					}
				}
			}
		}
	}

	checkCellsOpenCloseDoor(mob) {
		/*
		if (!mob.canOpenDoors()) {
			if (mob.cell.isDoor()) {
				if (!mob.cell.isLockedDoor()) {
					this.toInteract.push({ type: "door", cell: mob.cell, action: "open" });
				}
			}
			return;
		}
		*/
		// Apre le porte nella prima serie di celle appena attorno al mob
		if (mob.canOpenDoors()) {
			let around0 = this.model.getCellsAround(0, mob.cell);
			around0.push(mob.cell);
			for (let x = 0; x < around0.length; x++) {
				let cell = around0[x];
				if (cell) {
					if (cell.isDoor()) {
						if (!cell.isLockedDoor()) {
							//cell.openDoor();
							this.toInteract.push({ type: "door", cell: cell, action: "open", priority: 1 });
						}
					}
				}
			}
		} else {
			if (mob.cell.isDoor()) {
				if (!mob.cell.isLockedDoor()) {
					this.toInteract.push({ type: "door", cell: mob.cell, action: "open", priority: 1 });
				}
			}
		}
		// Chiude le porte nella seconda serie di celle attorno al mob o nelle dialognali
		let around1 = this.model.getCellsAround(3, mob.cell);
		for (let x = 0; x < around1.length; x++) {
			let cell = around1[x];
			if (cell) {
				if (cell.isDoor()) {
					//cell.closeDoor();
					this.toInteract.push({ type: "door", cell: cell, action: "close", priority: 0 });
				}
			}
		}
		let around2 = this.model.getCellsAround(1, mob.cell);
		for (let x = 0; x < around2.length; x++) {
			let cell = around2[x];
			if (cell) {
				if (cell.isDoor()) {
					//cell.closeDoor();
					this.toInteract.push({ type: "door", cell: cell, action: "close", priority: 0 });
				}
			}
		}
	}


	canMoveMob(mob, incx, incy, lHelp = true) {
		if (this.levelWon) {
			if (mob.id === this.mobInCamera.id) {
				return [true, true];
			}
		}

		// Controlla se un mob può muoversi in una determinata cella nelle due (eventuali) direzioni
		if (Game.DEBUG_NO_COLLISION) {
			if (mob.clas === "hero") {
				return [true, true];
			}
		}
		let ret = [false, false];
		if ((incx !== 0) && (incy !== 0)) {
			let can = this.canMoveMobSingledirection(mob, incx, 0);
			ret[0] = can;
			can = this.canMoveMobSingledirection(mob, 0, incy);
			ret[1] = can;

			if (incy < 0) {
				if (!ret[1]) {
					if (ret[0]) {
						if (incx < 0) {
							mob.setAnimation("walk_w");
						} else if (incx > 0) {
							mob.setAnimation("walk_e");
						}
					}
				} else {
					if (ret[0]) {
						mob.setAnimation("walk_n");
					}
				}
			}

		} else {
			let can = this.canMoveMobSingledirection(mob, incx, incy);
			if (incx !== 0) {
				ret[0] = can;
			} else {
				ret[1] = can;
			}
		}

		if (lHelp) {
			if (!ret[0] && !ret[1]) {
				// Controlla se "accompagnare" il giocatore
				let lCheck = false;
				if ((incx === 0) && (incy !== 0)) {
					lCheck = true;
				}
				if ((incx !== 0) && (incy === 0)) {
					lCheck = true;
				}
				if (lCheck) {

					let cells = this.getCellsWhereMobWouldStand(mob, incx, incy);
					let cant = new Array();
					for (let x = 0; x < cells.length; x++) {
						if (cells[x]) {
							if (!cells[x].canWalk()) {
								cant.push(cells[x]);
							}
						}
					}
					if (cant.length === 1) {
						let cell = cant[0]
						//let posMob = mob.mc.position();
						let posMob = mob.position();
						posMob.top += mob.height / 2;
						posMob.left += mob.width / 2;
						let posCell
						//try { // PQP
						// posCell =cell.tiles[0].position();
						posCell = cell.position() //{ top: cell.row * this.tileh, left: cell.col * this.tilew };
						//} catch (e) {
						//console.log(cell)
						//}
						if (incx !== 0) {
							if ((cell.col < mob.cell.col) || (cell.col > mob.cell.col)) {
								if (posMob.top > posCell.top + (this.tileh / 4) * 3) {
									let s = this.model.getNearbyCell(cell, Maze.DIR_S);
									if (s) {
										if (s.canWalk()) {
											ret[1] = true;
											ret.push(Math.abs(incx));
										}
									}
								}
								if (posMob.top < posCell.top + this.tileh / 4) {
									let n = this.model.getNearbyCell(cell, Maze.DIR_N);
									if (n) {
										if (n.canWalk()) {
											ret[1] = true;
											ret.push(-Math.abs(incx));
										}
									}
								}
							}
						}
						if (incy !== 0) {
							if ((cell.row < mob.cell.row) || (cell.row > mob.cell.row)) {
								if (posMob.left > posCell.left + (this.tilew / 4) * 3) {
									let e = this.model.getNearbyCell(cell, Maze.DIR_E);
									if (e) {
										if (e.canWalk()) {
											ret[0] = true;
											ret.push(Math.abs(incy));
										}
									}
								}
								if (posMob.left < posCell.left + this.tilew / 4) {
									let w = this.model.getNearbyCell(cell, Maze.DIR_W);
									if (w) {
										if (w.canWalk()) {
											ret[0] = true;
											ret.push(-Math.abs(incy));

										}
									}
								}
							}
						}
					}
				}
			}
		}

		return ret;
	}

	canMoveMobSingledirection(mob, incx, incy) {
		//let pos = mob.mc.position();
		let pos = mob.position();
		// Prende le celle sulle quali sarebbe
		let mobCells = this.getCellsWhereMobWouldStand(mob, incx, incy);
		for (let x = 0; x < mobCells.length; x++) {
			if (mobCells[x]) {
				if (!mobCells[x].canWalk(mob)) {
					return false;
				}
			} else {
				return false;
			}
		}
		return true;
	}

	getCellsWhereMobWouldStand(mob, incx, incy) {
		return this.getCellsWhereMobStands(mob, incx, incy);
	}

	getCellsWhereMobStands(mob, incx = 0, incy = 0) {
		let cell = mob.cell;//this.current;
		let ret = [cell];
		//let posMob = mob.mc.position();
		let posMob = mob.position();
		/*if (!mob.inView) {
			console.log(mob.mc)
			console.log(mob.mc.position());
		}*/
		posMob.top = posMob.top + incy;
		posMob.left = posMob.left + incx;
		//let posCell = cell.tiles[0].position();
		let posCell = { top: cell.row * this.tileh + this.deltay * this.tileh, left: cell.col * this.tilew + this.deltax * this.tilew }
		let wMob = mob.width;
		let hMob = mob.height;

		let quali = []
		if ((posMob.top < posCell.top) && (posMob.left + wMob > posCell.left + this.tilew)) {
			quali.push([cell.row - 1, cell.col + 1]);
		} else if ((posMob.top < posCell.top) && (posMob.left < posCell.left)) {
			quali.push([cell.row - 1, cell.col - 1]);
		} else if ((posMob.top + hMob > posCell.top + this.tileh) && (posMob.left + wMob > posCell.left + this.tilew)) {
			quali.push([cell.row + 1, cell.col + 1]);
		} else if ((posMob.top + hMob > posCell.top + this.tileh) && (posMob.left < posCell.left)) {
			quali.push([cell.row + 1, cell.col - 1]);
		}
		if (posMob.top < posCell.top) {
			quali.push([cell.row - 1, cell.col]);
		}
		if (posMob.top + hMob > posCell.top + this.tileh) {
			quali.push([cell.row + 1, cell.col]);
		}
		if (posMob.left < posCell.left) {
			quali.push([cell.row, cell.col - 1]);
		}
		if (posMob.left + wMob > posCell.left + this.tilew) {
			quali.push([cell.row, cell.col + 1]);
		}

		for (let x = 0; x < quali.length; x++) {
			ret.push(this.model.getCellDirect(quali[x][0], quali[x][1]));
		}
		return ret;
	}

	getCellMobBelongMore(mob, cells) {
		// Ritorna la cella in cui il mob è "più presente" (la sua area occupa uno spazio maggiore)
		let max = -10000000;
		let cell = null;
		for (let x = 0; x < cells.length; x++) {
			if (cells[x]) {
				let a = [
					//mob.mc.position().left,
					//mob.mc.position().left + mob.width,
					mob.position().left,
					mob.position().left + mob.width,
					cells[x].col * this.tilew + this.deltax * this.tilew,
					cells[x].col * this.tilew + this.tilew + this.deltax * this.tilew
				];
				let b = [
					//mob.mc.position().top,
					//mob.mc.position().top + mob.height,
					mob.position().top,
					mob.position().top + mob.height,
					cells[x].row * this.tileh + this.deltay * this.tileh,
					cells[x].row * this.tileh + this.tileh + this.deltay * this.tileh
				];
				a.sort(function (a, b) {
					return a - b;
				});
				b.sort(function (a, b) {
					return a - b;
				});
				let p0 = { x: a[1], y: b[1] };
				let p1 = { x: a[2], y: b[2] };
				let area = Math.abs((p1.x - p0.x) * (p1.y - p0.y));
				if (area > max) {
					max = area;
					cell = cells[x];
				}
			}
		}
		return cell;
	}

	addMob(mob, cell, spanX = 0, spanY = 0) {
		// Aggiunge un mob sulla mappa
		//console.log(spanX, spanY)
		mob.cell = cell;
		this.mobs.push(mob);
		/*mob.mc.css({
			top: cell.row * this.tileh + this.deltay * this.tileh + spanY,
			left: cell.col * this.tilew + this.deltax * this.tilew + spanX
		});*/
		mob.top = cell.row * this.tileh + this.deltay * this.tileh + spanY;
		mob.left = cell.col * this.tilew + this.deltax * this.tilew + spanX;

		mob.setZFromCell(cell, this.model);
		cell.mobGenerated = mob;

	}

	showMob(mob, lPrepend = false) {
		if (lPrepend) {
			if (mob.mc.parent().length == 0) {
				//jQuery(".js-layer-0", this.layersPanel).prepend(mob.mc);
				jQuery(".js-layer-mobs", this.layersPanel).prepend(mob.mc);
				mob.setInfoable();
			}
		} else {
			if (mob.mc.parent().length == 0) {
				//jQuery(".js-layer-0", this.layersPanel).append(mob.mc);
				jQuery(".js-layer-mobs", this.layersPanel).append(mob.mc);
				mob.setInfoable();
			}
		}
	}

	hideMob(mob) {
		if (mob.mc.parent().length > 0) {
			mob.mc.remove();
		}
	}

	moveCamera(incx, incy) {
		let mob = this.mobInCamera;
		let dirx, diry
		dirx = -incx;
		diry = -incy;
		let pos = this.layersPanel.position();

		// Non la sposta se è ai bordi
		let cell = mob.cell;

		if (cell.col < Math.floor(this.cols / 2)) {
			dirx = 0;
		}
		if (cell.row < Math.floor(this.rows / 2)) {
			diry = 0;
		}

		if (cell.col > this.model.cols - Math.ceil(this.cols / 2)) {
			dirx = 0;
		}
		if (cell.row > this.model.rows - Math.ceil(this.rows / 2)) {
			diry = 0;
		}

		// Controlla se i limiti vengono rispettati
		if (pos.left <= - (this.layersPanel.width() - this.tilew * this.cols)) {
			pos.left = - (this.layersPanel.width() - this.tilew * this.cols);
			if (dirx < 0) {
				dirx = 0;
			}
		}
		if (pos.left >= 0) {
			pos.left = 0;
			if (dirx > 0) {
				dirx = 0;
			}
		}

		if (pos.top <= - (this.layersPanel.height() - this.tileh * this.rows)) {
			pos.top = - (this.layersPanel.height() - this.tileh * this.rows)
			if (diry < 0) {
				diry = 0;
			}
		}
		if (pos.top >= 0) {
			pos.top = 0;
			if (diry > 0) {
				diry = 0;
			}
		}

		// Controlla se deve aggiustare la matrice di celle
		if ((dirx !== 0) || (diry !== 0)) {
			this.checkAddRemoveBoundingTilesFromPanel();
			this.layersPanel.css({
				top: pos.top + diry,
				left: pos.left + dirx
			})
		}

	}

	checkAddRemoveBoundingTilesFromPanel() {
		// Controlla se è cambiato il bounding box
		let changedA = this.checkBoundingBox();
		// Controlla se le celle sulle quali si trova il mob sono cambiate
		let changedB = this.mobCellsHaveChanged();
		// Controlla se la cella principale del mob è cambiata
		let changedC = this.mobCurrentCellHasChanged();

		// Se qualcosa è cambiato fa il check delle tiles ai bordi e rimuove quelle più distanti
		if (changedA || changedB || changedC) {
			this.addRemoveBoundingTilesFromPanel()
		}
	}

	addRemoveBoundingTilesFromPanel() {
		this.addTiles(this.currentBoundingBox);
		this.removeTiles(this.currentBoundingBox);
	}


	addTiles(box) {
		let cells = new Array();
		let tmp;

		tmp = this.model.getCellsSubset(box.top - 2, box.left - 2, box.top - 1, box.right + 1);
		cells = cells.concat(tmp);
		tmp = this.model.getCellsSubset(box.bottom, box.left - 2, box.bottom + 1, box.right + 1);
		cells = cells.concat(tmp);
		tmp = this.model.getCellsSubset(box.top, box.left - 2, box.bottom - 1, box.left - 1);
		cells = cells.concat(tmp);
		tmp = this.model.getCellsSubset(box.top, box.right, box.bottom - 1, box.right + 1);
		cells = cells.concat(tmp);

		for (let x = 0; x < cells.length; x++) {
			cells[x].createTiles(this.sp);
			cells[x].activateTilesAnimations(true);
			this.placeTiles(cells[x]);
		}
	}

	placeTiles(cell, deltax = 0, deltay = 0) {
		if (!cell.shown) {
			if (cell.hasTiles()) {
				cell.shown = true;
				let a = cell.tiles;
				for (let x = 0; x < a.length; x++) {
					let tile = a[x];
					if (tile) {
						tile.css({
							top: cell.row * this.tileh + deltay * this.tileh,
							left: cell.col * this.tilew + deltax * this.tilew
						})
						if (!this.model.hasFov()) {
							jQuery(".js-layer-" + x, this.layersPanel).append(tile);
						}
					}
				}
			}
		}
	}

	removeTiles(box) {
		let cells = new Array();
		let tmp;
		tmp = this.model.getCellsSubset(box.top - 3, box.left - 3, box.top - 3, box.right + 2);
		cells = cells.concat(tmp);
		tmp = this.model.getCellsSubset(box.bottom + 2, box.left - 3, box.bottom + 2, box.right + 2);
		cells = cells.concat(tmp);
		tmp = this.model.getCellsSubset(box.top - 2, box.left - 3, box.bottom + 1, box.left - 3);
		cells = cells.concat(tmp);
		tmp = this.model.getCellsSubset(box.top - 2, box.right + 2, box.bottom + 1, box.right + 2);
		cells = cells.concat(tmp);
		for (let x = 0; x < cells.length; x++) {
			cells[x].activateTilesAnimations(false);
			this.removeTile(cells[x]);
		}
	}

	removeTile(cell) {
		if (cell) {
			if (cell.shown) {
				if (cell.hasTiles()) {
					let a = cell.tiles;
					for (let x = 0; x < a.length; x++) {
						if (a[x]) {
							a[x].remove();
						}
					}
					cell.shown = false;
				}
			}
		}
	}

	mobCurrentCellHasChanged() {
		let mob = this.mobInCamera;
		if (mob.oldCell !== mob.cell) {
			return true
		}
		return false;
	}


	mobCellsHaveChanged() {
		let mob = this.mobInCamera;
		if (mob.oldCells) {
			if (mob.oldCells.length === mob.cells.length) {
				for (let x = 0; x < mob.oldCells.length; x++) {
					let cell = mob.oldCells[x];
					let lFound = false;
					for (let y = 0; y < mob.cells.length; y++) {
						//if (mob.oldCells)
						if (cell.id === mob.cells[y].id) {
							lFound = true;
							break;
						}
					}
					if (!lFound) {
						return true;
					}
				}
				return false;
			}
		}
		return true;
	}

	checkBoundingBox() {
		let mob = this.mobInCamera;
		let box = this.getBoundingBox(mob.cell);
		if (this.currentBoundingBox) {
			if (this.differentBoundingBoxes(this.currentBoundingBox, box)) {
				this.currentBoundingBox = box;
				return true;
			}
		} else {
			this.currentBoundingBox = box;
		}
		return false;
	}

	differentBoundingBoxes(box0, box1) {
		if (box0.left !== box1.left) {
			return true;
		}
		if (box0.top !== box1.top) {
			return true;
		}
		if (box0.bottom !== box1.bottom) {
			return true;
		}
		if (box0.right !== box1.right) {
			return true;
		}
		return false;
	}


	checkIfCloseChests() {
		let mob = this.mobInCamera;
		let a = this.chestsCurrentOpened;
		let tmp = new Array();
		for (let x = 0; x < a.length; x++) {
			let chest = a[x].mobGenerated;
			if (chest.isOpened()) {
				let s = this.model.getNearbyCell(a[x], Maze.DIR_S);
				if (s) {
					if (s.id === mob.cell.id) {
						tmp.push(a[x])
					} else {
						this.dispatch({ type: TileMap.EVENT_CLOSE_CHEST, data: { chest: chest } });
						chest.close();
					}
				}
			}
		}
		this.chestsCurrentOpened = tmp;
	}


	findItemOnWhichInteract() {
		let mob = this.mobInCamera;
		if (mob.facing === Maze.DIR_N) {
			let n = this.model.getNearbyCell(mob.cell, Maze.DIR_N);
			if (n) {
				if (n.isChest()) {
					this.openChest(n);
				}
				if (n.hasTorch()) {
					if (!n.isTorchLit()) {
						this.lightTorch(n)
					} else {
						this.unlightTorch(n)
					}
				}
				if (n.isFireplace()) {
					this.lightFireplace(n)
				}

			}
		} else if (mob.facing === Maze.DIR_S) {
			let s = this.model.getNearbyCell(mob.cell, Maze.DIR_S);
			if (s.isFireplace()) {
				this.lightFireplace(s)
			}
		} else if (mob.facing === Maze.DIR_E) {
			let e = this.model.getNearbyCell(mob.cell, Maze.DIR_E);
			if (e) {
				if (e.isChest()) {
					this.openChest(e);
				}
			}


			if (e.isFireplace()) {
				this.lightFireplace(e)
			}
		} else if (mob.facing === Maze.DIR_W) {
			let w = this.model.getNearbyCell(mob.cell, Maze.DIR_W);
			if (w) {
				if (w.isChest()) {
					this.openChest(w);
				}
			}

			if (w.isFireplace()) {
				this.lightFireplace(w)
			}
		}

	}

	lightFireplace(cell) {
		let fireplace = cell.mobGenerated;
		if (fireplace.isLit()) {
			Helper.alert("Confirm", "Do you really want to rest until you fully recovered your hit points?", this.feedbackRest.bind(this));

		} else {
			fireplace.light();
		}
		if (this.torchChecked.indexOf(cell.id) < 0) {
			this.torchChecked.push(cell.id);
			Player.checkSkill(Skills.SKILL_CAMPING);
		}

		if (!Bout.gv("explainedFireplace")) {
			Helper.alert("Bonfire", "Now it's lit: you can rest (press E again) or you can cook your cookable food (click on the food on your inventory)!", null, 1);
			Bout.sv("explainedFireplace", true);
		}


	}

	feedbackRest(ris) {
		if (ris) {
			if (Bout.that.player.isFullyHealed()) {
				Helper.alert("Rest", "You are already fully healed!", null, 1);
			} else {
				let alertWin = Helper.alert("Sweet dreams!", "Resting...", null, 0);
				setTimeout(this.endRest.bind(this, alertWin), 3000);
			}
		}

	}

	endRest(alertWin) {
		Helper.removeAlert(false, alertWin);
		Bout.that.player.restHeal();
	}


	lightTorch(cell) {
		cell.setTorchLit(true);
		if (this.torchChecked.indexOf(cell.id) < 0) {
			this.torchChecked.push(cell.id);
			Player.checkSkill(Skills.SKILL_CAMPING);
			Bout.incStatistic(Bout.STAT_TORCHES, 1);
			Bout.incStatistic(Bout.STAT_SCORE, Game.SCORE_TORCH_LIT);
		}
	}
	unlightTorch(cell) {
		cell.setTorchLit(false);
	}


	openChest(cell) {
		let chest = cell.mobGenerated
		if (!chest.isOpened()) {
			this.chestsCurrentOpened.push(cell);
			//let items = chest.open();
			this.dispatch({ type: TileMap.EVENT_OPEN_CHEST, data: { chest: chest } });
		}
	}



	showFovCell(mobs, radius, row, col, distRows, distCols) {
		let cell = this.model.maze[row][col];
		this.fovCells.push(cell);
		let tiles = cell.tiles;
		if (tiles) {

			let lAdd = true;
			if (tiles.length > 0) {
				for (let y = 0; y < this.oldFovCells.length; y++) {
					if (this.oldFovCells[y].id === cell.id) {
						if (cell.tiles[0].parent().length > 0) {
							lAdd = false;
						}
						break;
					}
				}
			}
			if (lAdd) {
				for (let x = 0; x < 3; x++) {
					if (tiles[x]) {
						jQuery(".js-layer-" + x, this.layersPanel).append(tiles[x]);
						tiles[x].css("opacity", 1);
					}
				}
				if (tiles[0]) {
					tiles[0].css("opacity", 0);
					this.fovThingsToShow.push(tiles[0]);
				}
				if (tiles[1]) {
					tiles[1].css("opacity", 0);
					this.fovThingsToShow.push(tiles[1]);
				}

			}
			if (tiles[2]) {
				let mult = 1 / radius//this.model.fovRadius;
				let dist = Math.max(Math.abs(distCols), Math.abs(distRows)) - 1;
				//tiles[2].html("" + dist)
				if (dist < 0) {
					dist = 0;
				}

				let opacity = mult * dist;

				if (dist === radius - 1) {//this.model.fovRadius - 1) {
					opacity = 1;
				}

				if (radius === 2) {
					if (dist === 0) {
						opacity = 0;
					} if (dist === 1) {
						opacity = mult;
					}
				}


				if (cell.firstPass) {
					//tiles[2].css("opacity", opacity);
					tiles[2].css("opacity", opacity);
					cell.firstPass = false;
				} else {
					let currentOpacity = tiles[2].css("opacity");
					if (currentOpacity < opacity) {
						opacity = currentOpacity;
					}
					tiles[2].css("opacity", opacity);
				}

				for (let x = 0; x < mobs.length; x++) {
					if (mobs[x].cell.id === cell.id) {
						if (opacity != 1) {
							if (mobs[x].id !== this.mobInCamera.id) {
								//mobs[x].mc.css("opacity", 1);
								//if (lAdd) {
								mobs[x].mc.css("opacity", 1);
								//mobs[x].mc.css("opacity", 0);
								//this.fovThingsToShow.push(mobs[x].mc)
								//}
							} else {
								if (!this.levelWon) {
									//mobs[x].mc.css("opacity", 1);
									//if (lAdd) {
									mobs[x].mc.css("opacity", 1);
									//mobs[x].mc.css("opacity", 0);
									//this.fovThingsToShow.push(mobs[x].mc)
									//}
								}
							}
						}
					}
				}
			}
		}
	}

	hideFovCells() {
		/*
		for (let x = 0; x < this.fovCells.length; x++) {
			this.fovCells[x].firstPass = true;
		}*/

		if ((this.fovCells) && (this.oldFovCells)) {
			for (let x = 0; x < this.oldFovCells.length; x++) {
				let cell = this.oldFovCells[x];
				cell.firstPass = true;
				let lRemove = true;
				for (let y = 0; y < this.fovCells.length; y++) {
					if (this.fovCells[y].id === cell.id) {
						this.fovCells[y].firstPass = true;
						lRemove = false;
						break;
					}
				}

				if (lRemove) {
					let tiles = cell.tiles;
					for (let y = 0; y < 3; y++) {
						if (tiles[y]) {
							tiles[y].remove();
							tiles[y].css("opacity", 1)
						}
					}

				}
			}
		}
	}

	hideMobsInBoundingBoxBut(mobs, mobRef) {
		for (let x = 0; x < mobs.length; x++) {
			let mob = mobs[x];
			if (mob.id !== mobRef.id) {
				mob.mc.css("opacity", 0);
			}
		}
	}

	getMobsInBoundingBox() {
		let ret = new Array();
		for (let x = 0; x < this.mobs.length; x++) {
			let mob = this.mobs[x];
			if (this.isInBoundingBox(mob, this.currentBoundingBox)) {
				ret.push(mob);
				if (this.mobInCamera.id === mob.id) {
					this.showMob(mob, true);
				} else {
					this.showMob(mob);
				}
				mob.setInView(true);

			} else {
				this.hideMob(mob);
				mob.setInView(false);
			}
		}
		return ret;

	}

	getMobPairsInView(mobs) {
		let ret = new Array();
		for (let x = 0; x < mobs.length; x++) {
			let mob0 = mobs[x];
			for (let y = 0; y < mobs.length; y++) {
				let mob1 = mobs[y];
				if (mob0.id !== mob1.id) {
					let lFound = false;
					for (let z = 0; z < ret.length; z++) {
						if (((ret[z].mob0.id === mob0.id) && (ret[z].mob1.id === mob1.id)) || ((ret[z].mob1.id === mob0.id) && (ret[z].mob0.id === mob1.id))) {
							lFound = true;
							break;
						}
					}
					if (!lFound) {
						ret.push({ mob0: mob0, mob1: mob1 });
					}
				}
			}
		}
		return ret;
	}

	getMobsNear(pairs) {
		let ret = new Array();
		for (var x = 0; x < pairs.length; x++) {
			if (this.mobsAreNear(pairs[x].mob0, pairs[x].mob1)) {
				ret.push(pairs[x]);
			}
		}
		return ret;
	}

	mobsAreNear(mob0, mob1) {
		let cells = this.model.getCellsAround(2, mob0.cell);
		cells.push(mob0.cell);
		//console.log(cells)
		for (let x = 0; x < cells.length; x++) {
			if ((mob1.cell.row === cells[x].row) && (mob1.cell.col === cells[x].col)) {
				return true;
			}
		}
		return false;
	}



	isInBoundingBox(mob, box) {
		if ((mob.cell.row + 1 >= box.top) && (mob.cell.row <= box.bottom)) {
			if ((mob.cell.col + 1 >= box.left) && (mob.cell.col <= box.right)) {
				return true;
			}
		}
		return false;
	}


	setMobsZIndex(pairs) {
		for (let x = 0; x < pairs.length; x++) {
			pairs[x].mob0.setZFromCell(pairs[x].mob0.cell, this.model);
			pairs[x].mob1.setZFromCell(pairs[x].mob1.cell, this.model);
		}
	}

	checkIfSwapZIndex(pairs) {
		for (let x = 0; x < pairs.length; x++) {
			let mob0 = pairs[x].mob0;
			let mob1 = pairs[x].mob1;
			let lMajor = true;

			if (mob1.type === Door.TYPE_SECRET) {
				if (!mob1.horizontal) {
					lMajor = false;
				}
			}

			if (mob0.type === Door.TYPE_SECRET) {
				if (!mob0.horizontal) {
					lMajor = false;
				}
			}


			// sto pezzo fa cagare
			if (lMajor) {
				//if (mob0.mc.position().top + mob0.height > mob1.mc.position().top + mob1.height) {
				if (mob0.position().top + mob0.height > mob1.position().top + mob1.height) {
					if (mob0.zindex <= mob1.zindex) {
						this.swapZindex(mob0, mob1);
					}
				} else {
					if (mob1.zindex <= mob0.zindex) {
						this.swapZindex(mob1, mob0);
					}
				}
			} else {
				//if (mob0.mc.position().top + mob0.height >= mob1.mc.position().top + mob1.height) {
				if (mob0.position().top + mob0.height >= mob1.position().top + mob1.height) {
					if (mob0.zindex <= mob1.zindex) {
						this.swapZindex(mob0, mob1);
					}
				} else {
					if (mob1.zindex <= mob0.zindex) {
						this.swapZindex(mob1, mob0);
					}
				}

			}
		}
	}

	swapZindex(mob0, mob1) {
		let tmp = mob0.zindex;
		mob0.setZDirect(mob1.zindex + 1);
		mob1.setZDirect(tmp);
	}

	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}

	playIntro() {
		let cell = this.model.startCell;
		let where = this.getCellsWhereMobStands(this.mobInCamera);
		this.mobInCamera.setSpeed(Control.SPEED_VERY_SLOW);

		if (cell.row === 0) {
			this.dispatch({ type: TileMap.EVENT_MOVE_S });
			let s = this.model.getNearbyCell(cell, Maze.DIR_S);
			if (where.length === 1) {
				if (this.mobInCamera.cell.id === s.id) {
					//if (this.mobInCamera.mc.position().top > s.tiles[0].position().top) {
					if (this.mobInCamera.position().top > s.tiles[0].position().top) {
						this.introShown = true;
						this.adjustMobPosition(this.mobInCamera, false);
						this.dispatch({ type: TileMap.EVENT_MOVE_STOP });
					}
				}
			}
		}
		if (cell.row === this.model.rows - 1) {
			this.dispatch({ type: TileMap.EVENT_MOVE_N });
			let n = this.model.getNearbyCell(cell, Maze.DIR_N);
			if (where.length === 1) {
				if (this.mobInCamera.cell.id === n.id) {
					//if (this.mobInCamera.mc.position().top < n.tiles[0].position().top + (this.tileh / 3)) {
					if (this.mobInCamera.position().top < n.tiles[0].position().top + (this.tileh / 3)) {
						this.introShown = true;
						this.adjustMobPosition(this.mobInCamera, true);
						this.dispatch({ type: TileMap.EVENT_MOVE_STOP });
					}
				}
			}
		}
		if (cell.col === 0) {
			this.dispatch({ type: TileMap.EVENT_MOVE_E });
			let e = this.model.getNearbyCell(cell, Maze.DIR_E);
			if (where.length === 1) {
				if (this.mobInCamera.cell.id === e.id) {
					//if (this.mobInCamera.mc.position().left + this.mobInCamera.width / 2 > e.tiles[0].position().left + (this.tilew / 2)) {
					if (this.mobInCamera.position().left + this.mobInCamera.width / 2 > e.tiles[0].position().left + (this.tilew / 2)) {
						this.introShown = true;
						this.adjustMobPosition(this.mobInCamera, false);
						this.dispatch({ type: TileMap.EVENT_MOVE_STOP });
					}
				}
			}
		}
		if (cell.col === this.model.cols - 1) {
			this.dispatch({ type: TileMap.EVENT_MOVE_W });
			let w = this.model.getNearbyCell(cell, Maze.DIR_W);
			if (where.length === 1) {
				if (this.mobInCamera.cell.id === w.id) {
					//if (this.mobInCamera.mc.position().left + this.mobInCamera.width / 2 < w.tiles[0].position().left + (this.tilew / 2)) {
					if (this.mobInCamera.position().left + this.mobInCamera.width / 2 < w.tiles[0].position().left + (this.tilew / 2)) {
						this.introShown = true;
						this.adjustMobPosition(this.mobInCamera, true);
						this.dispatch({ type: TileMap.EVENT_MOVE_STOP });
					}
				}
			}
		}
	}

	adjustMobPosition(mob, lAdd) {
		let speed = mob.originalSpeed;
		//let mc = this.mobInCamera.mc;
		let cell = this.mobInCamera.cell;
		//let difx = mc.position().left - cell.tiles[0].position().left;
		//let dify = mc.position().top - cell.tiles[0].position().top;
		let difx = mob.position().left - cell.tiles[0].position().left;
		let dify = mob.position().top - cell.tiles[0].position().top;
		let tmp = Math.floor(difx / speed);
		difx = difx - tmp * speed;
		if (lAdd) {
			difx = speed - difx;
		}
		tmp = Math.floor(dify / speed);
		dify = dify - tmp * speed;
		if (lAdd) {
			dify = speed - dify;
		}
		//console.log(mc.position().top, mc.position().left)

		//mc.css({ top: mc.position().top + dify, left: mc.position().left + difx });
		//mob.top = mc.position().top + dify;
		//mob.left = mc.position().left + difx;
		mob.top = mob.position().top + dify;
		mob.left = mob.position().left + difx;

		//console.log(mc.position().top, mc.position().left)
		//console.log(difx,dify)
	}

	closeEntrance() {
		this.closedEntrance = true;
		this.model.startCell.dropBuilder();
		this.mobInCamera.setSpeed(Control.SPEED_NORMAL);
		this.dispatch({ type: TileMap.EVENT_ENTERED });

	}

	checkWon() {

		if (this.mobInCamera.cell.id === this.model.endCell.id) {
			let where = this.getCellsWhereMobStands(this.mobInCamera);
			//if (where.length === 1) {
			if (!this.levelWon) {
				//this.tmpCount = 0;
				this.levelWon = true;
				this.dispatch({ type: TileMap.EVENT_MOVE_STOP });
				TweenMax.to(this.mobInCamera.mc, 1.5, { css: { opacity: 0 }, onComplete: this.exited.bind(this) });
				if (this.model.getWhatBorderTheCellBelongsTo(this.model.endCell) !== Maze.DIR_W) {
					TweenMax.to(jQuery(".js-sprite", this.mobInCamera.mc), 1.5, { css: { scale: 0.75 } });
				}
			}
			//}
		}
	}


	playOutro() {
		let cell = this.model.endCell;
		let where = this.getCellsWhereMobStands(this.mobInCamera);
		//this.oldTmpPos = this.tmpPos;
		//this.tmpPos = this.mobInCamera.mc.position();
		//console.log(where)
		this.mobInCamera.setSpeed(Control.SPEED_VERY_SLOW);

		if (cell.row === 0) {
			this.dispatch({ type: TileMap.EVENT_MOVE_N });
		}
		if (cell.row === this.model.rows - 1) {
			this.dispatch({ type: TileMap.EVENT_MOVE_S });
		}
		if (cell.col === 0) {
			this.dispatch({ type: TileMap.EVENT_MOVE_W });
		}
		if (cell.col === this.model.cols - 1) {
			this.dispatch({ type: TileMap.EVENT_MOVE_E });
		}

		/*let lInc = false;
		if (this.oldTmpPos && this.tmpPos) {
			if (this.oldTmpPos.left === this.tmpPos.left) {
				if (this.oldTmpPos.top === this.tmpPos.top) {
					this.tmpCount++;
					this.mobInCamera.mc.css("opacity",)
					lInc = true;
				}
			}
		}
		if (!lInc) {
			this.tmpCount = 0;
		}
		if (this.tmpCount === 64) {
			this.outroShown = true;
			this.dispatch({ type: TileMap.EVENT_EXITED });
		}*/



	}
	exited() {
		this.outroShown = true;
		this.dispatch({ type: TileMap.EVENT_EXITED });

	}


	levelCompleted() {
		this.destroyed = true;
		this.dispatch({ type: TileMap.EVENT_REACHED_EXIT });
	}

	mainLoop() {
		if (this.destroyed) {
			return;
		}

		if (Game.DEBUG_INSTANT_WIN) {
			this.introShown = true;
			this.closedEntrance = true;
			this.stoppedInteractionAtEndLevel = true;
			this.dispatch({ type: TileMap.EVENT_EXITING });
			this.exited();
		}

		// Controlla i controller dei mob
		for (let x = 0; x < this.mobs.length; x++) {
			this.mobs[x].checkController();
		}

		// Controlla se deve portare avanti qualche decisione di qualche ai
		this.checkDecisions();


		if (!this.introShown) {
			this.playIntro();
		}
		if (this.introShown) {
			if (!this.closedEntrance) {
				this.closeEntrance();
			}
		}

		// Muove i mob in coda
		this.moveMobsInQueue();



		// Prende in considerazione solo i mob nell'area visibile
		let mobs = this.getMobsInBoundingBox();

		// Controlla i mob nella viewport
		let pairs = this.getMobPairsInView(mobs);
		// Aggiusta il loro z-index secondo la cella in cui si trovano
		if (pairs.length > 0) {
			this.setMobsZIndex(pairs);
		} else {
			// Aggiusta almeno lo zindex di quello nella camera
			this.mobInCamera.setZFromCell(this.mobInCamera.cell, this.model);
		}
		// Controlla quelli che sono a distanza di una cella o meno tra loro
		let nears = this.getMobsNear(pairs);
		//console.log(nears)

		// Scambia il loro z-index in modo che quello più in alto risulti più in profondità
		this.checkIfSwapZIndex(nears);

		// Controlla le tiles vicine per vedere se aprire una porta
		this.checkIfOpenCloseDoors();

		// Controlla le ceste aperte per vedere se le deve chiudere
		this.checkIfCloseChests();

		// Apre e chiude le porte ed interagisce con gli oggetti
		this.doInteractionInQueue();

		// Controlla se attivare l'ai dei mob
		this.checkIfActivateMobAi(mobs);

		// Controlla se i mob hanno spottato l'eroe
		this.checkIfMobsSpottedHero(mobs);

		// Controlla se deve attivare una spike
		this.checkIfActivateSpike();

		// Controlla se la spike colpisce un mob
		this.checkIfSpikeHarmSomeone(mobs);




		// se il fov è attivo rende visibili le celle vicino all'eroe (e i mobs o gli static)
		if (this.model.hasFov()) {

			//setTimeout(this.showFovThingsToShow.bind(this), 100);
			requestAnimationFrame(this.showFovThingsToShow.bind(this));
			//this.showFovThingsToShow.bind(this);

			// Nasconde tutti i mob nel bounding box
			this.hideMobsInBoundingBoxBut(mobs, this.mobInCamera);
			// calcola le celle visibili
			this.oldFovCells = this.fovCells;
			this.fovCells = new Array();
			// Hero
			//this.pfov.compute(this.mobInCamera.cell.col, this.mobInCamera.cell.row, this.model.fovRadius, this.showFovCell.bind(this, mobs));
			//this.pfov.compute(this.mobInCamera.cell.col, this.mobInCamera.cell.row, Hero.RADIUS, this.showFovCell.bind(this, mobs, Hero.RADIUS));
			this.pfov.compute(this.mobInCamera.cell.col, this.mobInCamera.cell.row, this.getMobInCameraRadius(), this.showFovCell.bind(this, mobs, this.mobInCamera.radius));
			// Torce
			for (let x = 0; x < this.model.torches.length; x++) {
				if (this.model.torches[x].isTorchLit()) {
					let s = this.model.getNearbyCell(this.model.torches[x], Maze.DIR_S);
					if (s) {
						//this.pfov.compute(s.col, s.row, this.model.fovRadius - 1, this.showFovCell.bind(this, mobs));
						this.pfov.compute(s.col, s.row, Torch.RADIUS, this.showFovCell.bind(this, mobs, Torch.RADIUS));
					}
				}
			}

			// rimuove le celle che non sono più presenti 
			this.hideFovCells()

		}

		// Controlla se ha raggiunto l'uscita
		this.checkWon();

		if (this.levelWon) {
			if (!this.stoppedInteractionAtEndLevel) {
				this.dispatch({ type: TileMap.EVENT_EXITING });
				this.stoppedInteractionAtEndLevel = true;
			}

			if (!this.outroShown) {
				this.playOutro();
			}
		}

		// Controlla se deve startare un combattimento
		this.checkIfStartAFight(nears);



	}


	getMobInCameraRadius() {
		//let radius = this.mobInCamera.radius;
		if (Screen.that.paperdoll.hasLantern()) {
			this.mobInCamera.radius = Hero.RADIUS_WITH_LANTERN;
		} else {
			this.mobInCamera.radius = Hero.RADIUS;
		}

		return this.mobInCamera.radius;
	}

	showFovThingsToShow() {
		let a = this.fovThingsToShow;
		for (let x = 0; x < a.length; x++) {
			a[x].css("opacity", 1);
		}

		this.fovThingsToShow = new Array();
	}

	checkIfActivateMobAi(mobs) {
		for (let x = 0; x < mobs.length; x++) {
			let mob = mobs[x];
			if (mob.hasAI()) {
				if (mob.isInView()) {
					if (mob.ai.isAsleep()) {
						mob.ai.asleep = false;
						mob.ai.think();
					}
				}
			}
		}

	}


	checkIfMobsSpottedHero(mobs) {
		for (let x = 0; x < mobs.length; x++) {
			let mob = mobs[x];
			if (mob.hasAI()) {
				if (mob.isInView()) {
					mob.ai.lookForHero();
				}
			}
		}
	}


	checkIfActivateSpike() {
		for (let x = 0; x < this.model.spikes.length; x++) {
			if (this.model.spikes[x].isProx()) {
				if (this.model.spikes[x].animatedTiles[0]) {
					if (this.model.spikes[x].animatedTiles[0].activated) {
						let cell = this.model.spikes[x];
						//console.log("spike")
						let n = this.model.getNearbyCell(cell, Maze.DIR_N);
						let s = this.model.getNearbyCell(cell, Maze.DIR_S);
						let e = this.model.getNearbyCell(cell, Maze.DIR_E);
						let w = this.model.getNearbyCell(cell, Maze.DIR_W);
						if ((Screen.that.hero.cell.id === n.id) || (Screen.that.hero.cell.id === s.id) || (Screen.that.hero.cell.id === w.id) || (Screen.that.hero.cell.id === e.id)) {
							let spike = this.model.spikes[x].animatedTiles[0];
							if (!spike.operating) {
								spike.proxOperate();

							}
						}
					}
				}
			}
		}
	}

	checkIfSpikeHarmSomeone(mobs) {
		for (let x = 0; x < this.model.spikes.length; x++) {
			let spike = this.model.spikes[x].animatedTiles[0];
			if (spike) {
				if (spike.activated) {
					if (spike.canHarm) {
						for (let y = 0; y < mobs.length; y++) {
							let mob = mobs[y];
							if (!mob.isStatic()) {
								if (mob.cells) {
									let cellBelong = this.getCellMobBelongMore(mob, mob.cells);
									if (cellBelong.id === this.model.spikes[x].id) {
										if (!mob.spiked) {
											if (!mob.isInvulnerable()) {
												if (mob.isHero()) {
													Bout.that.player.hp -= Spike.SPIKE_DAMAGE;
													Bout.incStatistic(Bout.STAT_DAMAGE_SUFFERED, Spike.SPIKE_DAMAGE);
													Bout.incStatistic(Bout.STAT_SPIKE_DAMAGE, Spike.SPIKE_DAMAGE);
													if (Bout.that.player.hp <= 0) {
														mob.setAnimation("hitmazedeath", this.gameOverByASpike.bind(this, mob));
													} else {
														mob.setAnimation("hitmaze", this.mobHitBySpikeEndAnimation.bind(this, mob));
													}
													mob.spiked = true;
													mob.controller.enable(false);
												} else {
													mob.spikedLevel++
													mob.setAnimation("hitmazeenemy", this.mobEnemyHitBySpikeEndAnimation.bind(this, mob));
													mob.spiked = true;
													mob.controller.enable(false);
													//console.log(mob.spikedLevel)
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}


	gameOverByASpike() {
		setTimeout(this.gameOver.bind(this), 2000);
	}

	gameOver() {
		this.dispatch({ type: TileMap.EVENT_GAME_OVER });
	}

	mobHitBySpikeEndAnimation(mob) {
		mob.spiked = false;
		mob.setInvulnerable(1000);
		mob.controller.enable(true);
	}
	mobEnemyHitBySpikeEndAnimation(mob) {
		mob.spiked = false;
		mob.setInvulnerable(3000);
		mob.controller.enable(true);
		//mob.ai.forceMove();
	}



	checkIfOpenCloseDoors() {
		for (let x = 0; x < this.mobs.length; x++) {
			let mob = this.mobs[x];
			if (!mob.isStatic()) {
				this.checkCellsOpenCloseDoor(mob);
			}
		}

	}


	moveMobsInQueue() {
		for (let x = 0; x < this.toMove.length; x++) {
			let o = this.toMove[x]
			this.doMoveMobTo(o.mob, o.incx, o.incy, o.lHelp);

		}
		this.toMove = new Array();

	}


	doInteractionInQueue() {
		let a = this.toInteract;

		this.toInteract.sort(function (a, b) {
			return b.priority - a.priority;
		});
		//console.log(this.toInteract.slice())


		for (let x = 0; x < a.length; x++) {
			let type = a[x].type;
			if (type === "door") {
				this.openCloseDoor(a[x]);
			}
			if (type === "fired") {
				this.findItemOnWhichInteract();
			}

		}
		this.toInteract = new Array();
	}

	openCloseDoor(o) {
		let action = o.action;
		if (action === "open") {
			o.cell.openDoor();
		}
		if (action === "close") {
			let canClose = true;
			let a = this.toInteract;
			// Controlla se per caso prima qualcuno la voleva aprire e quindi non la chiude
			for (let x = 0; x < a.length; x++) {
				let type = a[x].type;
				if (type === "door") {
					let action = a[x].action;
					if (action === "open") {
						if (o.cell.id === a[x].cell.id) {
							canClose = false;
							break;
						}
					}
				}
			}
			// Controlla se qualche mob ha una delle sue celle lì
			if (canClose) {
				for (let x = 0; x < this.mobs.length; x++) {
					let mob = this.mobs[x];
					if (mob.clas === "enemy") {
						let cells = this.getCellsWhereMobStands(mob);

						for (let y = 0; y < cells.length; y++) {
							if (cells[y].id === o.cell.id) {
								canClose = false;
								break;
							}
						}
						if (!canClose) {
							break;
						}
					}
				}
			}

			if (canClose) {
				o.cell.closeDoor();
			}
		}
	}
	addDecisionInProgress(decision) {
		this.decisionsInProgress.push(decision);
	}
	/*
	removeDecisionFromProgress(decision) {
		let tmp = new Array();
		for (let x = 0; x < this.decisionsInProgress; x++) {
			if (this.decisionsInProgress[x].id !== decision.id) {
				tmp.push(this.decisionsInProgress[x]);
			}
		}
		//console.log(this.decisionsInProgress.length, tmp.length)
		this.decisionsInProgress = tmp;
	}
	*/

	checkDecisions() {
		let a = this.decisionsInProgress.slice()
		for (let x = 0; x < a.length; x++) {
			a[x].checking();
			//console.log(this.decisionsInProgress[x])
		}
		//this.decisionsInProgress = new Array();
		//console.log("->"+this.decisionsInProgress.length)
		this.decisionsInProgress.splice(0, a.length);
		//console.log(this.decisionsInProgress.length)
	}

	getClip() {
		return this.mc;

	}

	showSkillGain(skill, value, inc) {
		//console.log(skill, value)
		//let msg = new Message("Your skill in " + Skills.getSkillName(skill) + " has increased by 0."+inc+"%. It is now " + Helper.toSkill(value), jQuery(".js-messages", this.mc));
		let msg = new Message("Your skill in " + Skills.getSkillName(skill) + " has increased by " + Helper.toSkill(inc) + ". It is now " + Helper.toSkill(value), jQuery(".js-messages", this.mc));
		msg.init();
	}

	showMessage(message) {
		let msg = new Message(message, jQuery(".js-messages", this.mc));
		msg.init();
	}

	setAreaMessages() {
		let div = jQuery("<div></div>");
		div.css({ width: 1, height: this.mc.height() })
		jQuery(".js-messages", this.mc).append(div);
	}


	checkIfStartAFight(nears) {
		for (let x = 0; x < nears.length; x++) {
			if (nears[x].mob0.isHero() || nears[x].mob1.isHero()) {
				if (nears[x].mob0.isEnemy() || nears[x].mob1.isEnemy()) {
					if (nears[x].mob0.cell.id == nears[x].mob1.cell.id) {
						this.dispatch({ type: TileMap.EVENT_START_FIGHT, data: { mob: nears[x].mob0.isHero() ? nears[x].mob1 : nears[x].mob0 } });
						break;
					}
				}
			}

		}
	}

	killMob(mob) {
		let a = this.mobs;
		for (let x = 0; x < a.length; x++) {
			//console.log(a[x]);
			if (a[x].id === mob.id) {
				mob.dispose();
				this.mobs.splice(x, 1);
				break;
			}
		}


	}


}


TileMap.ENUM = 0;
TileMap.EVENT_REACHED_EXIT = "eventReachedExit";
TileMap.EVENT_MOVE_N = "eventMoveN";
TileMap.EVENT_MOVE_S = "eventMoveS";
TileMap.EVENT_MOVE_E = "eventMoveE";
TileMap.EVENT_MOVE_W = "eventMoveW";
TileMap.EVENT_MOVE_STOP = "eventMoveStop";
TileMap.EVENT_EXITED = "eventExited"
TileMap.EVENT_EXITING = "eventExiting";
TileMap.EVENT_ENTERED = "eventEntered";
TileMap.EVENT_PAUSE_GAME = "eventPauseGame";
TileMap.EVENT_OPEN_CHEST = "eventOpenChest"
TileMap.EVENT_START_FIGHT = "eventStartFight"
TileMap.EVENT_GAME_OVER = "eventGameOver";

TileMap.STYLER = null;
